import { render, staticRenderFns } from "./LayoutWdmaHistRegister.vue?vue&type=template&id=6ee843b5"
import script from "./LayoutWdmaHistRegister.vue?vue&type=script&lang=js"
export * from "./LayoutWdmaHistRegister.vue?vue&type=script&lang=js"
import style0 from "./LayoutWdmaHistRegister.vue?vue&type=style&index=0&id=6ee843b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports